export default {
    TEXT: "text",
    PROJECTNUMBER: "project number",
    TYPE: "project type",
    PROJECTTYPE: "project type",
    PROJECTNAME: "project name",
    COMMENT: "comment",
    DESIGNENTRYTYPE: "design entry type",
    LINK: "link"
}


// WEBPACK FOOTER //
// ./src/constants/ProjectPropertiesType.js